import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { catchError, EMPTY, finalize, take } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false,
})
export class LoginComponent {
    form: FormGroup;

    loginInProgress = false;

    message: string | undefined = undefined;

    constructor(
        private readonly fb: FormBuilder,
        public readonly authService: AuthService,
    ) {
        this.form = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
        });
    }

    login() {
        if (this.form.valid) {
            this.loginInProgress = true;
            this.message = undefined;
            this.authService
                .login(this.form.get('email')?.value, this.form.get('password')?.value)
                .pipe(
                    take(1),
                    finalize(() => {
                        this.loginInProgress = false;
                    }),
                    catchError((err) => {
                        if (err === 'Invalid login credentials') {
                            this.message = 'الايميل او كلمة المرور غير صحيحة';
                        }
                        return EMPTY;
                    }),
                )
                .subscribe();
        }
    }
}
